import { BUSINESS } from "@/data";
import { SectionHeading, CallButton, QuoteButton } from "./Buttons";
import * as Icons from "lucide-react";

const STEPS = [
  { n: "01", t: "Bring your device", d: "Walk in with your phone, charger, and any accessories." },
  { n: "02", t: "We inspect it", d: "Condition, storage, carrier status, and battery health — all checked on the spot." },
  { n: "03", t: "Get a real offer", d: "Transparent quote with no pressure. Take it or leave it." },
  { n: "04", t: "Get paid or trade", d: "Cash on the spot, or trade toward your next device." },
];

export default function SellPhone({ onOpenQuote }) {
  return (
    <section id="sell" data-testid="sell-section" className="relative bg-white py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Trade-In & Cash Out"
          title={<>Want to sell or<br />trade your phone?</>}
          sub="Bring your phone in and we'll check the condition, storage, carrier status, and give you a real offer — no online lowball tricks."
          testid="sell-heading"
        />

        <div className="mt-12 md:mt-16 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {STEPS.map((s, i) => (
              <div
                key={s.n}
                data-testid={`sell-step-${i}`}
                className="card-soft card-soft-hover p-6 md:p-7"
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-display text-3xl font-black text-brand-red">{s.n}</span>
                  <div className="flex-1 h-px bg-gradient-to-r from-brand-red/40 to-transparent" />
                </div>
                <h4 className="font-display font-extrabold text-xl text-brand-navy">{s.t}</h4>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>

          <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-brand-red to-brand-red-dark text-white p-8 md:p-10 shadow-xl">
            <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-white/10 blur-2xl" />
            <Icons.DollarSign className="w-12 h-12 text-white/80 mb-4" strokeWidth={2.2} />
            <div className="text-xs font-bold uppercase tracking-widest text-white/80 mb-2">In-store offer</div>
            <h4 className="font-display text-2xl md:text-3xl font-black leading-tight">Real cash. Same day.<br />No mailing required.</h4>
            <div className="mt-7 flex flex-col gap-2.5">
              <QuoteButton testid="sell-quote-btn" onClick={onOpenQuote} variant="secondary" size="md" className="w-full">Get a Quote</QuoteButton>
              <a
                href={`tel:${BUSINESS.phoneTel}`}
                data-testid="sell-call-btn"
                className="inline-flex items-center justify-center gap-2 font-bold rounded-full py-2.5 px-5 text-sm bg-white/15 hover:bg-white/25 text-white border border-white/20 transition-all"
              >
                <Icons.Phone className="w-4 h-4" />
                Call First
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
